<template>
  <div class="pt-3">
    <b-container v-if="typeof dist_zone_data !== 'undefined'" class="pt-4">
      <b-row>
        <b-col sm="12" md="6" class="mb-2">
          <b-form-input type="text" :placeholder="trans['PESQUISA']" v-model="filter"></b-form-input>
        </b-col>
        <b-col cols="12" style="overflow-x:auto;">
          <table class="table text-center table-striped">
            <thead class="bg-grey-dark text-white">
              <tr>
                <th scope="col" class="align-middle">{{trans['BLOCO']}}</th>
                <th scope="col" class="align-middle">{{trans['PISO']}}</th>
                <th scope="col" class="align-middle">{{trans['N_QUARTO']}}</th>
                <th scope="col" class="align-middle">{{trans['ESTADO_RESERVA']}}</th>
                <th scope="col" class="align-middle">{{trans['ESTADO_QUARTO']}}</th>
                <th scope="col" class="align-middle">{{trans['ESTADO_LIMPEZA']}}</th>
                <th scope="col" class="align-middle" style="width: 120px;">{{trans['INSPECAO_GOVERNANTA']}}</th>
                <th scope="col" class="align-middle" style="width: 120px;">{{trans['INSPECAO_DIRECAO']}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(room, key) in rooms_data" :key="key">
                <td scope="row" v-html="highlight_matches(room.room.floor.block.description)"></td>
                <td scope="row" v-html="highlight_matches(room.room.floor.floor_name)"></td>
                <td scope="row" v-html="highlight_matches(room.room.room_number)"></td>
                <td scope="row" v-html="highlight_matches(get_reservation_state(room))"></td>
                <td scope="row" v-html="highlight_matches(get_room_status_name(room))"></td>
                <td scope="row" v-html="highlight_matches(get_state(room).name)"></td>
                <td scope="row">{{ room.inspected_housekeeper ? room.inspected_housekeeper : '---' }}</td>
                <td scope="row">{{ room.inspected_director ? room.inspected_director : '---' }}</td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>

export default {
  name: 'zone_rooms',
  data() {
    return {
      filter: ''
    }
  },
  methods: {
    highlight_matches(text) {
      const matchExists = text.toLowerCase().includes(this.filter.toLowerCase());
      if (!matchExists) return text;

      const re = new RegExp(this.filter, 'ig');
      return text.replace(re, matchedText => `<strong class="color-green">${matchedText}</strong>`);
    }
  },
  computed: {
    rooms_data: function() {
      if( !Array.isArray(this.dist_zone_data) ){
        return this.dist_zone_data.rooms.filter(row => {
          const block             = row.room.floor.block.name.toLowerCase();
          const floor             = row.room.floor.floor_name.toLowerCase();
          const room              = row.room.room_number.toString().toLowerCase();
          const reservationStatus = (row.reservation_check_out) ? (row.reservation_check_out.estado.name.toLowerCase()) : '';
          const cleanStatus       = row.action.toLowerCase();
          const searchTerm        = this.filter.toLowerCase();
  
          return block.includes(searchTerm) ||
            floor.includes(searchTerm) || 
            room.includes(searchTerm) || 
            reservationStatus.includes(searchTerm) || 
            cleanStatus.includes(searchTerm);
        });

      } else {
        // If dist_zone_data is an array, for each zone, for each room, apply the filter
        let filteredRooms = [];
        this.dist_zone_data.forEach(zone => {
          zone.rooms.forEach(row => {
            const block             = row.room.floor.block.description.toLowerCase();
            const floor             = row.room.floor.floor_name.toLowerCase();
            const room              = row.room.room_number.toString().toLowerCase();
            const reservationStatus = (row.reservation_check_out) ? (row.reservation_check_out.estado.name.toLowerCase()) : '';
            const cleanStatus       = row.action.toLowerCase();
            const searchTerm        = this.filter.toLowerCase();

            if (
              block.includes(searchTerm) ||
              floor.includes(searchTerm) || 
              room.includes(searchTerm) || 
              reservationStatus.includes(searchTerm) || 
              cleanStatus.includes(searchTerm)
            ) {
              filteredRooms.push(row);
            }
          });
        });
        return filteredRooms;
      }
    },
    dist_zone_data: function() {
      return this.get_zone();
    },
    send_data: function(items) {}, // just to exist and no error when main container call this
  },
  created: function() {
    if(typeof this.dist_zone_data === 'undefined') {
      this.$router.push({name: 'login', params: {lang: this.$route.params.lang}});
      return;
    }
    this.$emit('set_back_link', { 
      name: 'list_rooms',
      params: {
          lang: this.$route.params.lang,
          dist_zone: this.dist_zone_data,
          search_hotel: this.$route.params.search_hotel,
          search_bloco: this.$route.params.search_bloco,
          search_piso: this.$route.params.search_piso,
          search_n_quarto: this.$route.params.search_n_quarto
        }
      });

      this.$route.meta.title = this.trans['QUARTOS']+' - '+this.trans['AREA'] +' '+ this.dist_zone_data.distribution_num;
      
      if( Array.isArray(this.dist_zone_data) && this.$distribution.person.view_all == 1 ){
        this.$route.meta.title = this.trans['QUARTOS'];
 
        this.$emit('set_back_link', { 
          name: 'list_zones',
          params: {
              lang: this.$route.params.lang,
              search_hotel: this.$distribution.search_hotel,
              search_bloco: this.$distribution.search_bloco,
              search_piso: this.$distribution.search_piso,
              search_n_quarto: this.$distribution.search_n_quarto
            }
          });
      }
  }
}
</script>
